import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../..";
import topTost from "../../utils/topTost";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Content2Header from "./Content2Header";
import { fetchFormData } from "../../utils/options";

const EditVideo = () => {
  const [video, setVideo] = useState([]);

  const [details, setDetails] = useState({});

  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!token) navigate("/");
  }, []);

  const toBase64 = (file) => {
    return new Promise((resolve) => {
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  };

  // Fetch content by ID
  const contentbyId = async () => {
    try {
      const response = await fetch(`${BaseUrl}contentbyid/${id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const data = result?.result?.data;
      if (!data) return;

      setDetails(data);

      // Map video array to match state structure
      const videos =
        data.video?.map((v) => ({
          id: Date.now() + Math.random(),
          file: null,
          video_file: v.video_file || null,
          file_url: v.video_url || null,
          youtube_url: v.youtube_url ? v.youtube_url.replace(/\\\//g, "/") : "",
          is_youtube: v.is_youtube === 1 ? 1 : 0,
          text: v.text || null,
        })) || [];

      setVideo(videos.length > 0 ? videos : []);

      if (videos.length > 0) setVideo(videos);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) contentbyId();
  }, [id]);

  // Add new video
  const addVideo = () => {
    setVideo((prev) => [
      ...prev,
      { id: Date.now(), file: null, youtube_url: "", is_youtube: 0, text: "" },
    ]);
  };

  const getVideoPath = (item) => {
    if (!item) return "";

    if (item.is_youtube == 1) return "";

    // Try full video URL first
    if (item.file_url) {
      try {
        const url = new URL(item.file_url);
        let path = url.pathname.replace(/^\/+/, "");

        return path;
      } catch {}
    }

    if (item.video_file) {
      return `uploads/content/${id}/${item.video_file}`;
    }

    return "";
  };

  // Remove video
  //remove content api

  const removeContent = async (item, index) => {
    if (item.is_youtube == 1) {
      setVideo((prev) => prev.filter((_, i) => i !== index));
      topTost({
        title:
          "Content removed. Click Update to permanently remove this content.",
        icon: "info",
      });

      return;
    }
    if (item.file && !item.file_url && !item.video_file) {
      setVideo((prev) => prev.filter((_, i) => i !== index));
      topTost({
        title:
          "Content removed. Click Update to permanently remove this content.",
        icon: "info",
      });

      return;
    }
    const filePath = getVideoPath(item);
    if (!filePath) return;
    const form = new FormData();
    form.append("url", filePath);
    try {
      const result = await fetchFormData(
        "content/remove-ContentFile",
        form,
        "POST"
      );

      if (result?.success || result?.code === 200) {
        topTost({
          title:
            "Content removed. Click Update to permanently remove this content.",
          icon: "info",
        });

        setVideo((prev) => prev.filter((_, i) => i !== index));
      } else {
        topTost({
          title: result?.result?.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };
  const extractYouTubeID = (url = "") => {
    if (!url) return null;

    const cleanUrl = url.replace(/\\/g, "").trim();

    // Short URL
    if (cleanUrl.includes("youtu.be/")) {
      return cleanUrl.split("youtu.be/")[1].split("?")[0];
    }

    if (cleanUrl.includes("watch?v=")) {
      return cleanUrl.split("watch?v=")[1].split("&")[0];
    }

    // Embed URL
    if (cleanUrl.includes("embed/")) {
      return cleanUrl.split("embed/")[1].split("?")[0];
    }

    return null;
  };

  const convertVideo = async (list) => {
    return Promise.all(
      list.map(async (item) => {
        // YouTube video
        if (item.is_youtube === 1) {
          if (!item.youtube_url) return null;

          return {
            is_youtube: 1,
            youtube_url: item.youtube_url,
            video: null,
            text: item.text || "",
          };
        }

        // Uploaded video (new file)
        if (item.is_youtube === 0 && item.file) {
          return {
            is_youtube: 0,
            video: await toBase64(item.file),
            text: item.text || "",
          };
        }

        // Existing uploaded video (unchanged)
        if (item.is_youtube === 0 && item.file_url) {
          return {
            is_youtube: 0,
            video: item.file_url,
            text: item.text || "",
          };
        }

        return null;
      })
    );
  };
  // Update all videos and submit
  const handleUpdateVideos = async () => {
    const invalidRow = video.find(
      (v) => v.text && !v.youtube_url && !v.video_file && !v.file_url && !v.file
    );
    if (invalidRow) {
      topTost({
        title: "Please select a Video file for the entered text",
        icon: "error",
      });
      return;
    }
    try {
      const converted = await convertVideo(video);

      const payload = {
        id,
        Video: converted.filter(Boolean),
      };

      const response = await fetch(`${BaseUrl}update-content-video`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("API Response:", result);

      if (result?.result?.code === 200) {
        topTost({ title: result?.result?.message, icon: "success" });
        setTimeout(() => navigate("/master/topic-list"), 600);
      } else {
        topTost({ title: result.message || "Update failed", icon: "error" });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Content2Header />
          </PageHeader>

          <div className="main-content">
            <div className="card mb-4 fw-bold">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#0e606e" }}
              >
                Edit Video
              </div>
              <div className="card-body">
                <div className="row ">
                  <div className="col-md-6 mb-2">
                    <strong>Course:</strong> {details.course_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Semester:</strong> {details.semester_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Subject:</strong> {details.subject_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Chapter:</strong> {details.chapter_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Title:</strong> {details.title || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>description:</strong> {details.description || "-"}
                  </div>
                </div>
              </div>
            </div>

            {/* Video List */}

            <div className="card mb-4">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead
                      style={{
                        display: "table-header-group",
                        backgroundColor: "#f1f1f1",
                        fontWeight: 600,
                      }}
                    >
                      <tr>
                        <th style={{ width: "40%" }}>Notes</th>
                        <th style={{ width: "10%" }}>Type</th>
                        <th style={{ width: "20%" }}>Input</th>
                        <th style={{ width: "40%" }}>Preview</th>
                        <th style={{ width: "15%" }}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {video.map((item, index) => (
                        <tr key={item.id}>
                          <td>
                            <textarea
                              className="form-control"
                              rows={5}
                              placeholder="Enter notes..."
                              value={item.text}
                              onChange={(e) => {
                                const value = e.target.value;
                                setVideo((prev) => {
                                  const updated = [...prev];
                                  updated[index] = {
                                    ...updated[index],
                                    text: value,
                                  };
                                  return updated;
                                });
                              }}
                            />
                          </td>
                          {/* Type */}
                          <td className="text-center">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={item.is_youtube == 1}
                                onChange={(e) => {
                                  const updated = [...video];
                                  const checked = e.target.checked;
                                  updated[index].is_youtube = checked ? 1 : 0;
                                  if (!checked) updated[index].youtube_url = "";
                                  updated[index].file = null;
                                  setVideo(updated);
                                }}
                              />
                              <label className="form-check-label">
                                Is YouTube?
                              </label>
                            </div>
                          </td>

                          {/* Input */}
                          <td>
                            {item.is_youtube == 1 ? (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="https://youtube.com/watch?v=..."
                                value={item.youtube_url}
                                onChange={(e) => {
                                  const updated = [...video];
                                  updated[index].youtube_url = e.target.value;
                                  setVideo(updated);
                                }}
                              />
                            ) : (
                              <>
                                <input
                                  type="file"
                                  accept="video/*"
                                  className="form-control"
                                  onChange={(e) => {
                                    const updated = [...video];
                                    updated[index].file = e.target.files[0];
                                    setVideo(updated);
                                  }}
                                />
                              </>
                            )}
                          </td>

                          {/* Preview */}
                          <td className="text-center">
                            {/* YouTube Preview */}
                            {item.is_youtube === 1 &&
                              item.youtube_url &&
                              (() => {
                                const videoId = extractYouTubeID(
                                  item.youtube_url
                                );
                                if (!videoId)
                                  return (
                                    <span className="text-danger">
                                      Invalid YouTube URL
                                    </span>
                                  );

                                return (
                                  <div
                                    style={{
                                      position: "relative",
                                      paddingBottom: "56.25%",
                                      height: 0,
                                    }}
                                  >
                                    <iframe
                                      src={`https://www.youtube.com/embed/${videoId}`}
                                      title={`YouTube Video ${index + 1}`}
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                    />
                                  </div>
                                );
                              })()}

                            {/* Uploaded Video Preview */}
                            {item.is_youtube == 0 &&
                              (item.file || item.file_url) && (
                                <video
                                  controls
                                  width="240"
                                  height="140"
                                  src={
                                    item.file
                                      ? URL.createObjectURL(item.file)
                                      : item.file_url
                                  }
                                  className="rounded border"
                                />
                              )}

                            {/* No Preview */}
                            {!item.youtube_url &&
                              !item.file &&
                              !item.file_url && (
                                <span className="text-muted">No preview</span>
                              )}
                          </td>

                          {/* Action */}
                          <td className="text-center">
                            {(item.text ||
                              item.video_file ||
                              item.youtube_url ||
                              item.file_url ||
                              item.file) && (
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => removeContent(item, index)}
                              >
                                Remove
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Add Video */}
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm mt-2"
                  onClick={addVideo}
                >
                  + Add More
                </button>

                <button
                  className="btn btn-success mt-3"
                  onClick={handleUpdateVideos}
                >
                  Update Video
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default EditVideo;
